import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/tail_dark_grey.svg'
import _imports_1 from '@/assets/img/tail_grey.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e268f0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cloud" }
const _hoisted_2 = { class: "d-flex align-items-center leftSide" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "title fw_600" }
const _hoisted_5 = { class: "questionAnswer" }
const _hoisted_6 = { class: "questionAnswer" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  key: 0,
  class: "title fw_600"
}
const _hoisted_9 = { class: "questionAnswer" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "fev_text5 time"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "blue",
  src: _imports_0
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grey",
  src: _imports_1
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cloud_container", _ctx.position])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.profileQuestion)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "questionAttached",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('attachmentClicked')))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "imageContainer",
                style: _normalizeStyle('background-image: url(\'' + _ctx.profileQuestion.imageUrl + '\')')
              }, [
                _createVNode(_component_love_face_shadow_bar, {
                  text: _ctx.profileQuestion.affintyRate + '%'
                }, null, 8, ["text"])
              ], 4),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.profileQuestion.name), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.profileQuestion.question), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.profileQuestion.answer), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.textMessageAttached)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "questionAttached textAttached",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('textAttachmentClicked')))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.textMessageAttached.senderInfo.text)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.textMessageAttached.senderInfo.text), 1))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    class: "title fw_600",
                    localizedKey: "app_you",
                    text: "You"
                  })),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.textMessageAttached.text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: "fev_text5",
        innerHTML: _ctx.getTextFormatted
      }, null, 8, _hoisted_10),
      (_ctx.time)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.time), 1))
        : _createCommentVNode("", true),
      _hoisted_12,
      _hoisted_13
    ])
  ], 2))
}